export default {
  getToken: (state) => state.token,
};
